import { render, staticRenderFns } from "./LoginData.vue?vue&type=template&id=1390f05b&scoped=true&"
import script from "./LoginData.vue?vue&type=script&lang=js&"
export * from "./LoginData.vue?vue&type=script&lang=js&"
import style0 from "./LoginData.vue?vue&type=style&index=0&id=1390f05b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390f05b",
  null
  
)

export default component.exports